import React from 'react';
import { Helmet } from 'react-helmet-async';

const MetaTags = ({ title, description, image, url, type = 'website' }) => {
  // Brand Defaults - Minimal & Authoritative
  const baseTitle = "idiawisdom.";
  const tagLine = "Berfikir tentang apa sahaja yang terlintas laju.";
  const defaultDesc = "Menulis untuk memperlahan apa yang terlintas itu. A personal archive of reflections, wisdom, and essays by Ben Hasan.";
  
  // Logic: If a specific title is provided (like a blog post title), 
  // we show "Post Title | idiawisdom."
  const displayTitle = title 
    ? `${title} | ${baseTitle}` 
    : `${baseTitle} — ${tagLine}`;

  const siteDescription = description || defaultDesc;
  const siteImage = image || 'https://idiawisdom.com/og-image.png'; 
  const siteUrl = url || 'https://idiawisdom.com';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{displayTitle}</title>
      <meta name="title" content={displayTitle} />
      <meta name="description" content={siteDescription} />
      <link rel="canonical" href={siteUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={displayTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="idiawisdom" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={displayTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={siteImage} />

      {/* Theme Color for Mobile Browsers (Zen White/Black) */}
      <meta name="theme-color" content="#ffffff" media="(prefers-color-scheme: light)" />
      <meta name="theme-color" content="#0c0a09" media="(prefers-color-scheme: dark)" />
    </Helmet>
  );
};

export default MetaTags;